import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import "../styles/loader.css";

export default function Loader() {
  return <div className="loader"></div>;
}
